import { render, staticRenderFns } from "./UserUpcomingReservations.vue?vue&type=template&id=858f79b0&scoped=true"
import script from "./UserUpcomingReservations.vue?vue&type=script&lang=js"
export * from "./UserUpcomingReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858f79b0",
  null
  
)

export default component.exports